export const getValues = (array, key, maxQty) => {
    var found = [];
    for (var i = 0; i <= array.length-1; i++) {
        found.push(array[i][key]);
        if (found.length >= maxQty) {
            break;
        }
    }
    return found;
}